import React, { useState, useEffect } from 'react';
import "./thankyou.scss";
import { useDispatch, useSelector } from 'react-redux';
import { getAppFlow } from '../../utils/app.utils';
import { APP_FLOW } from '../../../common/constant';
import Confetti from 'react-confetti';
import { updatePaymentData } from '../../../redux/actions/userAction';
var tweenFunctions = require('tween-functions');
tweenFunctions.easeOutBounce(0, 0, 1, 0);

const Thankyou = () => {
    const user = useSelector((state) => state.userReducer)
    const deviceIsIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.userAgent.includes("Macintosh") && "ontouchend" in document);

    const dispatch = useDispatch()
    const [copyFeedback, setCopyFeedback] = useState('');
    const [toggleConfetti, setToggleConfetti] = useState(false);
    const [flowType, setFlowType] = useState(getAppFlow() === APP_FLOW.FIDYAH ? APP_FLOW.FIDYAH : APP_FLOW.ZAKAT)

    const tickIcon = <svg xmlns="http://www.w3.org/2000/svg" width="13.047" height="9.425" viewBox="0 0 13.047 9.425">
        <path id="tick-svgrepo-com_3_" data-name="tick-svgrepo-com (3)" d="M4.892,12,8.14,15.253,15.393,8" transform="translate(-3.619 -6.727)" fill="none" stroke="#008462" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </svg>


    useEffect(() => {
        let transactionPassed = { transactionPassed: true };
        dispatch(updatePaymentData({ ...user, ...transactionPassed }));
        setTimeout(() => {
            setToggleConfetti(false)
        }, 4000);
    }, [])

    const handleCopyToken = async () => {
        try {
            await navigator.clipboard.writeText(user.userData.token);
            setCopyFeedback('Copied!');
            setTimeout(() => setCopyFeedback(''), 2000);
        } catch (err) {
            console.error('Failed to copy token:', err);
            setCopyFeedback('Failed to copy');
            setTimeout(() => setCopyFeedback(''), 2000);
        }
    };

      const renderConfetti = () => {
            return (
                <>     
                <Confetti
                     width={window.innerWidth}
                     height={window.innerHeight}
                    recycle={toggleConfetti}
                    numberOfPieces={700}
                    friction={0.995}
                    wind={0.003}
                    initialVelocityY={deviceIsIOS ? 15 : 7}
                     gravity={deviceIsIOS ? 0.05 : 0.04}
                    confettiSource={{ x: 0, y: -10, w: 1170, h: -10 }}
                    tweenDuration={1000}
                    tweenFunction={tweenFunctions.easeOutBounce}
                    drawShape={ctx => {
                        let r = Math.floor(Math.random() * 4) + 9;
                        ctx.moveTo(r, 0);
                        ctx.beginPath();
                        for (let i = 0; i < 10; i++) {
                            ctx.rotate(Math.PI / 5);
                            if (i % 2 === 0) {
                                ctx.lineTo((r / 0.525731) * 0.200811, 0);
                            } else {
                                ctx.lineTo(r, 0);
                            }
                        }
                        ctx.closePath();
                        ctx.fill();
                        ctx.restore();
                    }}
                    colors={['#008462','#F1BA00']}
                ></Confetti>
                <Confetti
                     width={window.innerWidth}
                     height={window.innerHeight}
                    recycle={toggleConfetti}
                    numberOfPieces={850 / 5}
                    friction={0.995}
                    gravity={deviceIsIOS ? 0.05 : 0.04}
                    wind={0.03}
                    initialVelocityY={deviceIsIOS ? 15 : 7}
                    confettiSource={{ x: 0, y: -10, w: 1170, h: -10 }}
                    tweenDuration={100}
                    drawShape={ctx => {
                        ctx.beginPath();
                        ctx.arc(30, 0, 20, 0, 1 * Math.PI);
                        ctx.bezierCurveTo(20, 15, 40, 15, 50, 0);
                        ctx.closePath();
                        ctx.fill();
                    }}
                    colors={['#008462','#F1BA00']}
                ></Confetti>
                </>
            )
        }

    return (
        <>
            <div className='main-page'>
               {
                renderConfetti()
               }
                <div className='container'>
                    
                    <div className='thankyou'>
                        <div className='thank-you-icon'>
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="122.895" height="112.356" viewBox="0 0 122.895 112.356">
                                    <g id="Group_14779" data-name="Group 14779" transform="translate(-134.438 -197.678)">
                                        <g id="Group_14776" data-name="Group 14776" transform="translate(134.438 204.751)">
                                            <path id="Path_64664" data-name="Path 64664" d="M646.051,552.079a1.457,1.457,0,0,1-1.033-.426h0l-1.465-1.464a1.461,1.461,0,0,1,0-2.065l1.465-1.464a1.463,1.463,0,0,1,2.065,0l1.465,1.464a1.461,1.461,0,0,1,0,2.065l-1.465,1.464A1.457,1.457,0,0,1,646.051,552.079Zm-.249-1.211a.353.353,0,0,0,.5,0l1.465-1.464a.352.352,0,0,0,0-.5l-1.465-1.464a.352.352,0,0,0-.5,0l-1.465,1.464a.352.352,0,0,0,0,.5Z" transform="translate(-527.195 -468.408)" fill="#24caff" />
                                            <path id="Path_64665" data-name="Path 64665" d="M336.48,256.862a1.338,1.338,0,1,1,1.338-1.339A1.34,1.34,0,0,1,336.48,256.862Zm0-1.568a.23.23,0,1,0,.23.23A.231.231,0,0,0,336.48,255.294Z" transform="translate(-289.4 -242.919)" fill="#24caff" />
                                            <path id="Path_64666" data-name="Path 64666" d="M540.37,267.53a2.449,2.449,0,1,1,2.451-2.449A2.453,2.453,0,0,1,540.37,267.53Zm0-3.79a1.341,1.341,0,1,0,1.342,1.341A1.343,1.343,0,0,0,540.37,263.74Z" transform="translate(-445.965 -249.44)" fill="#24caff" />
                                            <path id="Path_64667" data-name="Path 64667" d="M151.946,529.883a1.276,1.276,0,0,1-.888-.357l-.007-.007-1.145-1.144a1.268,1.268,0,0,1,0-1.782l1.145-1.144a1.263,1.263,0,0,1,1.783,0l1.145,1.144a1.267,1.267,0,0,1,0,1.783l-1.144,1.144A1.253,1.253,0,0,1,151.946,529.883Zm-.116-1.153a.162.162,0,0,0,.22,0l1.144-1.144a.159.159,0,0,0,0-.214l-1.145-1.144a.161.161,0,0,0-.215,0l-1.145,1.144a.159.159,0,0,0,0,.214Z" transform="translate(-146.098 -452.076)" fill="#20ff86" />
                                            <path id="Path_64668" data-name="Path 64668" d="M632.344,460.35a1.528,1.528,0,0,1-1.063-.428l-.007-.006-1.543-1.542a1.516,1.516,0,0,1,0-2.131l1.543-1.542a1.508,1.508,0,0,1,2.13,0l1.543,1.542a1.509,1.509,0,0,1,0,2.13l-1.543,1.542A1.494,1.494,0,0,1,632.344,460.35Zm-.291-1.223a.409.409,0,0,0,.567,0l1.543-1.542a.408.408,0,0,0,0-.562l-1.543-1.542a.408.408,0,0,0-.563,0l-1.543,1.542a.408.408,0,0,0,0,.562Z" transform="translate(-516.514 -397.397)" fill="#fdc600" />
                                            <path id="Path_64669" data-name="Path 64669" d="M179.632,419.214a1.527,1.527,0,0,1-1.063-.428l-.007-.007-1.543-1.542a1.517,1.517,0,0,1,0-2.13l1.543-1.542a1.509,1.509,0,0,1,2.131,0l1.543,1.542a1.508,1.508,0,0,1,0,2.13l-1.543,1.542A1.5,1.5,0,0,1,179.632,419.214Zm-.291-1.223a.409.409,0,0,0,.567,0l1.543-1.542a.407.407,0,0,0,0-.562l-1.543-1.542a.408.408,0,0,0-.563,0l-1.543,1.542a.408.408,0,0,0,0,.562Z" transform="translate(-166.977 -365.636)" fill="#fdc600" />
                                            <path id="Path_64670" data-name="Path 64670" d="M355.56,646.084a1.528,1.528,0,0,1-1.063-.428l-.007-.007-1.543-1.542a1.516,1.516,0,0,1,0-2.13l1.543-1.542a1.509,1.509,0,0,1,2.131,0l1.543,1.542a1.508,1.508,0,0,1,0,2.13l-1.543,1.542A1.494,1.494,0,0,1,355.56,646.084Zm-.291-1.223a.409.409,0,0,0,.567,0l1.543-1.542a.408.408,0,0,0,0-.562l-1.543-1.542a.409.409,0,0,0-.563,0l-1.543,1.542a.408.408,0,0,0,0,.562Z" transform="translate(-302.81 -540.801)" fill="#fdc600" />
                                            <path id="Path_64671" data-name="Path 64671" d="M482.179,556.246a1.528,1.528,0,0,1-1.063-.428l-.007-.007-1.543-1.542a1.517,1.517,0,0,1,0-2.131l1.543-1.542a1.509,1.509,0,0,1,2.131,0l1.543,1.542a1.508,1.508,0,0,1,0,2.13l-1.543,1.542A1.5,1.5,0,0,1,482.179,556.246Zm-.291-1.223a.409.409,0,0,0,.567,0L484,553.485a.408.408,0,0,0,0-.562l-1.543-1.542a.408.408,0,0,0-.563,0l-1.543,1.542a.408.408,0,0,0,0,.562Z" transform="translate(-400.573 -471.438)" fill="#fdc600" />
                                            <path id="Path_64672" data-name="Path 64672" d="M168.607,283.636a.554.554,0,0,1-.555-.554,1.11,1.11,0,0,0-1.109-1.109.554.554,0,0,1,0-1.109,1.11,1.11,0,0,0,1.109-1.109.554.554,0,1,1,1.109,0,1.11,1.11,0,0,0,1.109,1.109.554.554,0,0,1,0,1.109,1.11,1.11,0,0,0-1.109,1.109A.554.554,0,0,1,168.607,283.636Zm-.2-2.217a2.219,2.219,0,0,1,.2.2,2.186,2.186,0,0,1,.2-.2,2.233,2.233,0,0,1-.2-.2A2.267,2.267,0,0,1,168.409,281.418Z" transform="translate(-159.108 -262.234)" fill="#20ff86" />
                                            <path id="Path_64673" data-name="Path 64673" d="M428.607,209.186a.554.554,0,0,1-.554-.554,1.11,1.11,0,0,0-1.109-1.109.554.554,0,1,1,0-1.109,1.11,1.11,0,0,0,1.109-1.109.554.554,0,0,1,1.109,0,1.11,1.11,0,0,0,1.109,1.109.554.554,0,0,1,0,1.109,1.11,1.11,0,0,0-1.109,1.109A.554.554,0,0,1,428.607,209.186Zm-.2-2.217a2.257,2.257,0,0,1,.2.2,2.22,2.22,0,0,1,.2-.2,2.22,2.22,0,0,1-.2-.2A2.257,2.257,0,0,1,428.409,206.968Z" transform="translate(-359.853 -204.751)" fill="#fdc600" />
                                            <path id="Path_64674" data-name="Path 64674" d="M136.655,366.446a.555.555,0,0,1-.554-.554,1.11,1.11,0,0,0-1.109-1.109.554.554,0,1,1,0-1.109,1.11,1.11,0,0,0,1.109-1.109.554.554,0,1,1,1.109,0,1.11,1.11,0,0,0,1.109,1.109.554.554,0,1,1,0,1.109,1.111,1.111,0,0,0-1.109,1.109A.554.554,0,0,1,136.655,366.446Zm-.2-2.218a2.263,2.263,0,0,1,.2.2,2.229,2.229,0,0,1,.2-.2,2.187,2.187,0,0,1-.2-.2A2.219,2.219,0,0,1,136.457,364.228Z" transform="translate(-134.438 -326.171)" fill="#fdc600" />
                                            <path id="Path_64675" data-name="Path 64675" d="M640.631,306.188a.554.554,0,0,1-.554-.554,3.145,3.145,0,0,0-3.141-3.142.554.554,0,1,1,0-1.109,3.145,3.145,0,0,0,3.141-3.141.554.554,0,1,1,1.109,0,3.145,3.145,0,0,0,3.142,3.141.554.554,0,0,1,0,1.109,3.145,3.145,0,0,0-3.142,3.142A.554.554,0,0,1,640.631,306.188Zm-1.6-4.25a4.283,4.283,0,0,1,1.6,1.6,4.283,4.283,0,0,1,1.6-1.6,4.283,4.283,0,0,1-1.6-1.6A4.283,4.283,0,0,1,639.032,301.938Z" transform="translate(-521.986 -276.507)" fill="#fdc600" />
                                            <path id="Path_64676" data-name="Path 64676" d="M215.18,247.44a.555.555,0,0,1-.554-.554.754.754,0,0,0-.753-.753.554.554,0,1,1,0-1.108.754.754,0,0,0,.753-.753.554.554,0,0,1,1.109,0,.754.754,0,0,0,.753.753.554.554,0,1,1,0,1.108.754.754,0,0,0-.753.753A.554.554,0,0,1,215.18,247.44Z" transform="translate(-195.341 -234.836)" fill="#24caff" />
                                        </g>
                                        <g id="Group_14777" data-name="Group 14777" transform="translate(147.288 205.678)" opacity="0.01">
                                            <path id="Path_64677" data-name="Path 64677" d="M190.82,256.493a47.673,47.673,0,1,1,47.673,47.673A47.7,47.7,0,0,1,190.82,256.493Z" transform="translate(-190.82 -208.82)" fill="none" stroke="#25b445" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
                                        </g>
                                        <g id="Group_14778" data-name="Group 14778" transform="translate(166.918 225.308)">
                                            <path id="Path_64678" data-name="Path 64678" d="M305,351.039A28.043,28.043,0,1,1,333.039,323,28.057,28.057,0,0,1,305,351.039Z" transform="translate(-276.953 -294.953)" fill="#25b445" />
                                            <path id="Path_64679" data-name="Path 64679" d="M305,351.039A28.043,28.043,0,1,1,333.039,323,28.057,28.057,0,0,1,305,351.039Z" transform="translate(-276.953 -294.953)" fill="none" stroke="#99f693" strokeLinecap="round" strokeLinejoin="round" strokeWidth="6" />
                                        </g>
                                        <path id="Path_64680" data-name="Path 64680" d="M359.89,397.318l5.911,5.911,12.372-12.372" transform="translate(-174.071 -143.692)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" />
                                    </g>
                                </svg>
                            </>
                        </div>
                        <div className='thank-you-head'>
                            <h2>Thank you!</h2>
                            <h6>Your {flowType === APP_FLOW.ZAKAT ? 'Zakat' : 'Fidyah'} Payment Token is shared to your <br />{user.userData.email && 'email Id -'} <span>{user.userData.email}</span> {user.userData.mobile && user.userData.email && 'and'} <span>{user.userData.mobile}</span></h6>
                            <div className='token-sec'>
                                <p> Token ID: <span>{user.userData.token}</span>
                                </p>
                                {copyFeedback && <p className='msg-tooltip'>{copyFeedback}</p>}
                                <button className='btn btn-transparent' onClick={handleCopyToken}>
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16.655" height="18.2" viewBox="0 0 16.655 18.2">
                                            <g id="style_linear" data-name="style=linear" transform="translate(-1.4 -0.4)">
                                                <g id="copy" transform="translate(2 1)">
                                                    <path id="rec" d="M15.371,14.136a3.252,3.252,0,0,0,3.22-3.284V4.284A3.252,3.252,0,0,0,15.371,1H10.22A3.252,3.252,0,0,0,7,4.284" transform="translate(-3.136 -1)" fill="none" stroke="#008462" strokeLinecap="round" strokeWidth="1.2" />
                                                    <path id="rec_2" d="M2,9.284A3.252,3.252,0,0,1,5.22,6h5.151a3.252,3.252,0,0,1,3.22,3.284v6.568a3.252,3.252,0,0,1-3.22,3.284H5.22A3.252,3.252,0,0,1,2,15.852Z" transform="translate(-2 -2.136)" fill="none" stroke="#008462" strokeWidth="1.2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </>
                                </button>
                            </div>
                            <h6 className='note-text'>Note: This token will expire in 2 hours.</h6>

                        </div>
                        <div className='thankyou-list'>
                            <ul className='thankyou-ul'>
                                <li className='thanku-list'>
                                    <div className="thankyou-icon">
                                        <>
                                            {tickIcon}
                                        </>
                                    </div>
                                    <div className='thankyou-caption'>
                                        <h5>
                                            Check your email or sms
                                        </h5>
                                        <p>
                                            Find your token ID in your inbox or SMS.
                                        </p>
                                    </div>
                                </li>
                                <li className='thanku-list'>
                                    <div className="thankyou-icon">
                                        <>
                                            {tickIcon}
                                        </>
                                    </div>
                                    <div className='thankyou-caption'>
                                        <h5>
                                            Keep token ready
                                        </h5>
                                        <p>
                                            Have the token ID handy for verification.
                                        </p>
                                    </div>
                                </li>
                                <li className='thanku-list'>
                                    <div className="thankyou-icon">
                                        <>
                                            {tickIcon}
                                        </>
                                    </div>
                                    <div className='thankyou-caption'>
                                        <h5>
                                            Visit zakat counter
                                        </h5>
                                        <p>
                                            Head to the amil (collector) with your token.
                                        </p>
                                    </div>
                                </li>
                                <li className='thanku-list'>
                                    <div className="thankyou-icon">
                                        <>
                                            {tickIcon}
                                        </>
                                    </div>
                                    <div className='thankyou-caption'>
                                        <h5>
                                            Complete payment
                                        </h5>
                                        <p>
                                            Confirm details, and make payment.
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Thankyou;